module.exports = __webpack_public_path__ + "697904d48f4d47ee9f02500453248f8b.svg";